module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/discreet.json
// module id = 720
// module chunks = 82744172129321